export default __webpack_public_path__ + "static/about-mobile-img-978ee04195fea89718518637aa1cd46a.png";